import Vue from 'vue'

// eslint-disable-next-line no-unused-vars
export default function (router) {
  const agora = new Date()
  const dataLimite = new Date('2026-05-19T23:59:59')

  const mostrarAvisoTemporario = agora <= dataLimite

  const abrirModalEnterprise = () => {
    Vue.swal({
      title: '<div style="color:#ed7d3e;">🚀 Novo Plano Enterprise disponível!</div>',
      html: `
        <div style="color:rgb(25, 48, 81); font-size: 18px;">
          <br>
          Olá!
          <br>
          Lançamos um pacote especial com novas funcionalidades:
          <br>
          <b>DTE, MIT, Parcelamentos Mei e novas integrações municipais.</b> Cada módulo possui valor individual.
          <br><br>
          Entre em contato com nosso suporte para saber mais.<br><br> 
          Para clientes do Plano Exclusivo, o parcelamento MEI já está liberado e pode ser configurado diretamente no sistema.
          <br><br><br>
          <b>Atenciosamente, Equipe Monitor Contábil</b>
        </div>
      `,
      icon: 'warning',
      iconColor: '#ed7d3e',
      confirmButtonText: 'OK',
      buttonsStyling: false,
      width: '35%',
      customClass: {
        popup: 'swal-m',
        confirmButton: 'btn btn-primary mt-2',
      },
    }).then(result => {
      if (result.isDenied) {
        router.push({ name: 'empresa-view', query: { filtroRapido: 'ApenasCPF' } })
      }
    })
  }

  if (mostrarAvisoTemporario) {
    Vue.swal({
      title: '<div style="color:#ed7d3e;">📢 Aviso Importante – Atendimento 19 de maio</div>',
      html: `
        <div style="color:rgb(25, 48, 81); font-size: 18px; text-align: left; line-height: 1.7;">
          <br>
          <p>No dia <b>19 de maio</b>, nosso atendimento será realizado exclusivamente pelos e-mails dos representantes:</p>
          <p>
            📧 rebeca.abreu@monitorcontabil.com.br<br>
            📧 ouvidoria@monitorcontabil.com.br
          </p>
          <p>Durante esse período, solicitamos que todas as solicitações, dúvidas e demandas de suporte sejam direcionadas para esses contatos, garantindo maior agilidade no retorno.</p>
          <p>Para tratar de assuntos relacionados a financeiro, utilize também os contatos acima ou o e-mail:</p>
          <p>📧 financeiro@monitorcontabil.com.br</p>
          <p>⏰ <b>Horário de atendimento:</b><br>De segunda a sexta-feira, das 08h30 às 18h.</p>
          <p>Agradecemos a compreensão e permanecemos à disposição para auxiliar no que for necessário.</p>
        </div>
      `,
      icon: 'info',
      iconColor: '#ed7d3e',
      confirmButtonText: 'Entendi',
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      width: '40%',
      customClass: {
        popup: 'swal-m',
        confirmButton: 'btn btn-primary mt-2',
      },
    }).then(() => {
      abrirModalEnterprise()
    })
  } else {
    abrirModalEnterprise()
  }
}
